import React, { useEffect, useContext } from "react";
import { AppContext } from "../../components/AppProvider";
import { userHabit } from "../../modules/utils/UserHabit";
import { closeLayerFn, openLayerFn } from "../Layout";


export const SetWalkTarget = () => {
    const {phonecfg} = useContext(AppContext);
    useEffect(() => {
        $(".open-walk-set").click(function () {
            openLayerFn($(".walk-target-set"));
            userHabit(phonecfg, 'EX100_P01');
        });
        //닫기
        $(".walk-target-set .tbns-area a").click(function () {
            closeLayerFn($(".walk-target-set"));
        });
    }, []);

    return (
        <div className="blacklayer-container walk-target-set">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">목표 걸음수 설정</div>

                    <div className="target-setting-box">
                        <div className="inly-sutit">목표 걸음수</div>
                        <div className="inly-backword">
                            <i>걸음</i>
                            <input type="text" className="textbox bld" defaultValue="10000" />
                        </div>
                    </div>

                    <div className="tbns-area">
                        <a className="btn-round gray">취소</a>
                        <a className="btn-round wht">확인</a>
                    </div>
                </div>
            </div>
        </div>
    );
};
